import * as React from 'react'
import { PreviewCard as BasePreviewCard } from '@base-ui/react/preview-card'
import { Trigger } from './nested/trigger'
import { Portal } from './nested/portal'
import { Backdrop } from './nested/backdrop'
import { Positioner } from './nested/positioner'
import { Popup } from './nested/popup'
import { Content } from './nested/content'
import type { PartProps } from '../../lib/part-props'

export interface PreviewCardProps extends PartProps<React.ComponentProps<typeof BasePreviewCard.Root>> {}

function PreviewCard(props: PreviewCardProps) {
  return <BasePreviewCard.Root {...props} />
}

PreviewCard.Trigger = Trigger
PreviewCard.Portal = Portal
PreviewCard.Backdrop = Backdrop
PreviewCard.Positioner = Positioner
PreviewCard.Popup = Popup
PreviewCard.Content = Content

export { PreviewCard }
